import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {ListaComponent} from "./pages/lista/lista.component";
import {PaginaDetalhesComponent} from "./pages/pagina-detalhes/pagina-detalhes.component";

const routes: Routes = [
  { path: "", component: ListaComponent },
  { path: "info-cliente/:id", component: PaginaDetalhesComponent }

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ClienteRoutingModule { }
